// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../styles/scrollbars.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UjuKCTijO0ohnsatygoF {
  display: flex;
  flex-direction: column;
  min-height: 0;
  height: 100%;
  background: #fff;
}

.o3n9mQwo8VHzVHlGxgaG {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 44px;
  padding: 0 16px;
  background: #fafafa;
  border-bottom: 1px solid #ebebeb;
}

.o3n9mQwo8VHzVHlGxgaG h2 {
  margin: 0;
  font-size: 13px;
  font-weight: 700;
  color: #1e1f23;
}

.u293tajvKYrEPQV6Grio {
  min-width: 30px;
  height: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: #f0f0f0;
  color: #777;
  font-size: 10px;
  font-weight: 700;
  padding: 0 8px;
}

.h_vt_qFGowhGPXUk_KIL {
  flex: 1;
  min-width: 0;
  max-width: 120px;
  margin-left: auto;
  height: 22px;
  border: 1px solid #ebebeb;
  border-radius: 6px;
  background: #f0f0f0;
  color: #555;
  font-size: 10px;
  padding: 0 8px;
}

.h_vt_qFGowhGPXUk_KIL::placeholder {
  color: #bbb;
}

.h6RvPIFyfqTxM6rwM6E1 {
  flex: 1;
  min-height: 0;
  overflow: auto;
}

.OF5y6_zEdeTcrbXSKaAh,
.T5wRRvDswNoJb_R1LTwt {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 90px 50px;
  align-items: center;
  min-height: 26px;
  border-bottom: 1px solid #ebebeb;
}

.OF5y6_zEdeTcrbXSKaAh {
  background: #f8f8f8;
  color: #999;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

/* The row's own cells only. As a descendant rule it also padded the icon,
   the name and the PK badge inside .fieldCell, 32 px each, which left the
   name two or three letters and no room for its ellipsis (#501). */
.OF5y6_zEdeTcrbXSKaAh > span,
.T5wRRvDswNoJb_R1LTwt > span {
  padding: 0 16px;
}

.T5wRRvDswNoJb_R1LTwt:nth-child(even) {
  background: rgba(0, 0, 0, 0.015);
}

.oAGz8yvt41nwU69bUKUJ {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  padding: 4px 16px;
}

.xuxNfotfO1buLqFLd1mF {
  width: 15px;
  height: 15px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  font-size: 9px;
  font-weight: 700;
  line-height: 1;
}

.pruasup83FfED3sbLNA_ {
  background: #dff2e1;
  color: #2f8f4a;
}

.suBErvKYLVjCHkihTAUl {
  background: #dce8ff;
  color: #3b6fd4;
}

.EbukqGEeQWCmXXwTWruv {
  background: #f3f4f6;
  color: #6b7280;
}

.d9CVvKMabCyTBCbaSVJf {
  background: #eadcfb;
  color: #7a4bd1;
}

.RAyP6IGZo1pkWh6zikPF {
  background: #dff2e1;
  color: #2f8f4a;
}

.J_QpVlaGRjrrx8g1Ul5z {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: "Fira Code", "Courier New", monospace;
  font-size: 12px;
  color: #1e1f23;
}

.gpEjSb3yaxiDFV2YED9N {
  flex-shrink: 0;
  height: 11px;
  display: inline-flex;
  align-items: center;
  border-radius: 5.5px;
  background: #fdf0e8;
  color: #fbaa69;
  font-size: 8px;
  font-weight: 700;
  padding: 0 6px;
  line-height: 1;
}

.hNRNTixaRQUXej8NMEMg {
  font-family: "Fira Code", "Courier New", monospace;
  font-size: 12px;
  color: #777;
}

.MhGOR4drWlD2VISiKzHS {
  font-family: "Fira Code", "Courier New", monospace;
  font-size: 12px;
  color: #777;
  text-transform: lowercase;
}

.KEOXR6i9WfiuvmyoGn2C {
  margin-top: auto;
  min-height: 40px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  background: #f8f8f8;
  border-top: 1px solid #ebebeb;
  color: #777;
  font-size: 11px;
}

.QpA9lGhV9atG965cVr8k {
  padding: 24px 16px;
  color: #85868b;
  font-size: 12px;
}

.R8Dj7IZvO3LcxQ64kqms {
  opacity: 0.55;
  transition: opacity 0.15s ease;
}
`, "",{"version":3,"sources":["webpack://./src/components/datasets/catalog/DatasetSchemaPanel.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EAEE,OAAO;EACP,aAAa;EACb,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;mEAEmE;AACnE;;EAEE,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,kDAAkD;EAClD,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kDAAkD;EAClD,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kDAAkD;EAClD,eAAe;EACf,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,6BAA6B;EAC7B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC","sourcesContent":[".panel {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  height: 100%;\n  background: #fff;\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-height: 44px;\n  padding: 0 16px;\n  background: #fafafa;\n  border-bottom: 1px solid #ebebeb;\n}\n\n.header h2 {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 700;\n  color: #1e1f23;\n}\n\n.countBadge {\n  min-width: 30px;\n  height: 18px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 9px;\n  background: #f0f0f0;\n  color: #777;\n  font-size: 10px;\n  font-weight: 700;\n  padding: 0 8px;\n}\n\n.filterInput {\n  flex: 1;\n  min-width: 0;\n  max-width: 120px;\n  margin-left: auto;\n  height: 22px;\n  border: 1px solid #ebebeb;\n  border-radius: 6px;\n  background: #f0f0f0;\n  color: #555;\n  font-size: 10px;\n  padding: 0 8px;\n}\n\n.filterInput::placeholder {\n  color: #bbb;\n}\n\n.tableWrap {\n  composes: thinScrollbar from \"../../../styles/scrollbars.module.css\";\n  flex: 1;\n  min-height: 0;\n  overflow: auto;\n}\n\n.headRow,\n.fieldRow {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 90px 50px;\n  align-items: center;\n  min-height: 26px;\n  border-bottom: 1px solid #ebebeb;\n}\n\n.headRow {\n  background: #f8f8f8;\n  color: #999;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n/* The row's own cells only. As a descendant rule it also padded the icon,\n   the name and the PK badge inside .fieldCell, 32 px each, which left the\n   name two or three letters and no room for its ellipsis (#501). */\n.headRow > span,\n.fieldRow > span {\n  padding: 0 16px;\n}\n\n.fieldRow:nth-child(even) {\n  background: rgba(0, 0, 0, 0.015);\n}\n\n.fieldCell {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n  padding: 4px 16px;\n}\n\n.typeIcon {\n  width: 15px;\n  height: 15px;\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 3px;\n  font-size: 9px;\n  font-weight: 700;\n  line-height: 1;\n}\n\n.iconGeometry {\n  background: #dff2e1;\n  color: #2f8f4a;\n}\n\n.iconInteger {\n  background: #dce8ff;\n  color: #3b6fd4;\n}\n\n.iconString {\n  background: #f3f4f6;\n  color: #6b7280;\n}\n\n.iconFloat {\n  background: #eadcfb;\n  color: #7a4bd1;\n}\n\n.iconBoolean {\n  background: #dff2e1;\n  color: #2f8f4a;\n}\n\n.fieldName {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-family: \"Fira Code\", \"Courier New\", monospace;\n  font-size: 12px;\n  color: #1e1f23;\n}\n\n.pkBadge {\n  flex-shrink: 0;\n  height: 11px;\n  display: inline-flex;\n  align-items: center;\n  border-radius: 5.5px;\n  background: #fdf0e8;\n  color: #fbaa69;\n  font-size: 8px;\n  font-weight: 700;\n  padding: 0 6px;\n  line-height: 1;\n}\n\n.typeCell {\n  font-family: \"Fira Code\", \"Courier New\", monospace;\n  font-size: 12px;\n  color: #777;\n}\n\n.nullCell {\n  font-family: \"Fira Code\", \"Courier New\", monospace;\n  font-size: 12px;\n  color: #777;\n  text-transform: lowercase;\n}\n\n.footer {\n  margin-top: auto;\n  min-height: 40px;\n  display: flex;\n  align-items: center;\n  padding: 0 16px;\n  background: #f8f8f8;\n  border-top: 1px solid #ebebeb;\n  color: #777;\n  font-size: 11px;\n}\n\n.state {\n  padding: 24px 16px;\n  color: #85868b;\n  font-size: 12px;\n}\n\n.panelRefreshing {\n  opacity: 0.55;\n  transition: opacity 0.15s ease;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panel": `UjuKCTijO0ohnsatygoF`,
	"header": `o3n9mQwo8VHzVHlGxgaG`,
	"countBadge": `u293tajvKYrEPQV6Grio`,
	"filterInput": `h_vt_qFGowhGPXUk_KIL`,
	"tableWrap": `h6RvPIFyfqTxM6rwM6E1 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["thinScrollbar"]}`,
	"headRow": `OF5y6_zEdeTcrbXSKaAh`,
	"fieldRow": `T5wRRvDswNoJb_R1LTwt`,
	"fieldCell": `oAGz8yvt41nwU69bUKUJ`,
	"typeIcon": `xuxNfotfO1buLqFLd1mF`,
	"iconGeometry": `pruasup83FfED3sbLNA_`,
	"iconInteger": `suBErvKYLVjCHkihTAUl`,
	"iconString": `EbukqGEeQWCmXXwTWruv`,
	"iconFloat": `d9CVvKMabCyTBCbaSVJf`,
	"iconBoolean": `RAyP6IGZo1pkWh6zikPF`,
	"fieldName": `J_QpVlaGRjrrx8g1Ul5z`,
	"pkBadge": `gpEjSb3yaxiDFV2YED9N`,
	"typeCell": `hNRNTixaRQUXej8NMEMg`,
	"nullCell": `MhGOR4drWlD2VISiKzHS`,
	"footer": `KEOXR6i9WfiuvmyoGn2C`,
	"state": `QpA9lGhV9atG965cVr8k`,
	"panelRefreshing": `R8Dj7IZvO3LcxQ64kqms`
};
export default ___CSS_LOADER_EXPORT___;
